import { useAccess } from "@templates/course/hooks/useAccess";
import Link from "next/link";
import { Fragment } from "react";

interface Props {
  removePadding?: boolean;
}

const exploreByCategoryLinkMaker = (categoryId: number) =>
  `/explore?publish_status=published&sort=most_sold&cost=not_free&category_id=${categoryId}&count=24`;

const CourseCategories: React.FC<Props> = ({ removePadding }) => {
  const { courseData } = useAccess();
  const {
    product: { categories },
  } = courseData;

  if (!categories.length) return null;
  return (
    <div className={removePadding ? "" : "py-6  md:py-8   px-4    "}>
      <h2 className="headline-sm md:headline-md text-fds-primary mb-3  lg:mb-5">
        دسته‌بندی موضوعی
      </h2>
      <div className="flex flex-wrap gap-2">
        {categories.map((m, index) => (
          <Fragment key={`${m.name}-${index}`}>
            <Link
              href={exploreByCategoryLinkMaker(m.id)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="bg-fds-brand-light flex items-center justify-center rounded-full px-2.5   h-8">
                <p className="text-fds-on-brand-light body-sm">{m.name}</p>
              </div>
            </Link>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default CourseCategories;
